import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import documentIcon from '../../images/document.svg';
import attachIcon from '../../images/attachDocument.svg';
import _ from 'lodash';
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';

const styles = () => {
	return {
		documentIcon: {
			marginRight: 12,
			display: 'inline-block',
			width: 34,
			height: 40,
			backgroundImage: `url('${documentIcon}')`,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			verticalAlign: 'middle',
			position: 'relative',
			flexShrink: 0,
			cursor: 'pointer',
		},
		attachIcon: {
			display: 'inline-block',
			width: 21,
			height: 21,
			backgroundImage: `url('${attachIcon}')`,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			verticalAlign: 'middle',
			position: 'absolute',
			bottom: 0,
			right: 0,
			transform: 'translate(30%, 30%)',
		},
		secondDocument: {
			position: 'absolute',
			zIndex: -1,
		},
	};
};

class InvoiceDocumentIcon extends PureComponent {
	render() {
		const { classes, invoiceDocument, isMissing, hasTooltip, onClick } = this.props;

		const { documentType, name } = invoiceDocument;
		const appendToInvoice = _.get(invoiceDocument, ['data', 'appendToInvoice'], false);

		let tooltipTitle;
		let icon;

		if (isMissing) {
			tooltipTitle = `Needed : ${name || documentType}`;
			icon = <div className={classes.documentIcon} style={{ opacity: 0.3 }} />;
		} else {
			tooltipTitle = `${name || documentType}`;
			icon = (
				<div
					className={classes.documentIcon}
					onClick={() => {
						onClick(invoiceDocument);
					}}
				>
					{appendToInvoice && <div className={classes.attachIcon} />}
				</div>
			);
		}

		if (hasTooltip) {
			return <Tooltip title={tooltipTitle}>{icon}</Tooltip>;
		} else {
			return icon;
		}
	}
}

InvoiceDocumentIcon.propTypes = {
	invoiceDocument: PropTypes.object,
	resourceMap: PropTypes.object,
	isMissing: PropTypes.bool,
	appendToInvoice: PropTypes.bool,
	classes: PropTypes.object.isRequired,
	hasTooltip: PropTypes.bool,
	onClick: PropTypes.func,
};

export default _.flow([withStyles(styles, { withTheme: true })])(InvoiceDocumentIcon);

InvoiceDocumentIcon.defaultProps = {
	hasTooltip: true,
};
